import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import TopUpThroughRetailer from "./TopUpThroughRetailer";
import { getMasterData } from "../../../services/userService";

const AsaanTopUp = ({ show, handleClose }) => {
  const [masterData, setMasterData] = useState("");
  const [productAmount, setProductAmount] = useState("");
  const [reRenderData, setReRenderData] = useState(true);
  const [showImage, setShowImage] = useState(true);
  const carrierType = "asaan";

  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const response = await getMasterData("");
        setMasterData(response?.data);
      } catch (error) {
        console.error(error?.message);
      }
    };

    if (show) {
      fetchMasterData();
    }
  }, [show]);

  const handleReRenderData = (response) => {
    setReRenderData(response);
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" centered backdrop="static" keyboard={false}>
      <div className="modal-simple">
        <div className="modal-content p-3 p-md-3 border-0 shadow-none">
          <Modal.Body className="p-0">
            <button type="button" onClick={handleClose} style={{ position: "absolute", right: "20px", top: "20px", zIndex: 10, background: "transparent", border: "none" }}>
              <i className="ti ti-x text-dark fw-bold" style={{ fontSize: "20px" }}></i>
            </button>
            <div className="row m-0">
              <TopUpThroughRetailer
                masterData={masterData}
                setShowProductSelect={() => {}}
                setProductAmount={setProductAmount}
                productAmount={productAmount}
                finalCommission=""
                productId=""
                handleReRenderData={handleReRenderData}
                setShowImage={setShowImage}
                showProductLink={false}
                setProductFlag={() => {}}
                convertedCurrency={null}
                carrierType={carrierType}
                setCarrierType={() => {}}
                mode="asaan"
                colClass="col-12"
              />
            </div>
          </Modal.Body>
        </div>
      </div>
    </Modal>
  );
};

export default AsaanTopUp;
